import { ReactElement } from 'react';
import { MenuItem, Button, styled, Select } from '@mui/material';
import { StyledSelect, byLabel } from '../common';
import {
  properties,
  ISearchableProperty,
  diProperties,
  labelP1,
  labelP2,
  enableP2,
  renderP2,
  renderP1,
  legacyProperties,
} from '.';
import { pathOr, always, path } from 'rambda';
import { tap } from 'lodash/fp';
import { map, filter, sortBy as fSortBy } from 'fp-ts/Array';
import { flow } from 'fp-ts/function';

export const RequstStatusFilter2d = ({
  di,
  legacy,
  searchBy,
  searchP1,
  searchP2,
  setSearchBy,
  setSearchP1,
  setSearchP2,
  search,
}: {
  di: boolean;
  legacy: boolean | undefined | null;
  searchBy: string;
  searchP1: string;
  searchP2: string;
  setSearchBy: React.Dispatch<React.SetStateAction<string>>;
  setSearchP1: React.Dispatch<React.SetStateAction<string>>;
  setSearchP2: React.Dispatch<React.SetStateAction<string>>;
  search: () => void;
}) => (
  <>
    <Form onSubmit={flow(e => e.preventDefault(), search)}>
      <label id="search-by" style={{ justifySelf: 'end' }}>
        Search By:
      </label>
      <StyledSelect
        labelId="search-by"
        value={searchBy}
        onChange={flow(
          pathOr('', 'target.value'),
          tap(setSearchBy),
          a => (a === 'reqType' ? 'SELECT_STATUS' : ''),
          setSearchP1,
          always(''), 
          setSearchP2
        )}
        variant="outlined">
        {flow(
          filter<ISearchableProperty | any>(pathOr(false, 'searchable')),
          fSortBy([byLabel]),
          map<ISearchableProperty, ReactElement>(({ value, label }) => (
            <MenuItem key={value} value={value}>{label}</MenuItem>
          ))
        )(legacy ? legacyProperties : di ? diProperties : properties)}
      </StyledSelect>

      {/* Label for first input or dropdown */}
      <label id="search-parameter-1" style={{ justifySelf: 'end' }}>
        {searchBy === 'reqType' ? 'Request Type' : path<string>(searchBy)(labelP1)}
      </label>

      {/* Either original input or new dropdown based on reqType */}
      {searchBy === 'reqType' ? (
        <Select
          value={searchP1}
          onChange={(e) => {
            setSearchP1(e.target.value);
            setSearchP2(e.target.value); // for consistency if needed elsewhere
          }}
          variant="outlined"
          style={{ minWidth: '120px' }}
          displayEmpty
        >
          <MenuItem value="">-- Select --</MenuItem>
          <MenuItem value="ENROLL">ENROLL</MenuItem>
          <MenuItem value="RENEWAL">RENEWAL</MenuItem>
          <MenuItem value="REVOKE">REVOKE</MenuItem>
        </Select>
      ) : (
        renderP1({
          di: di,
          csa: false,
          searchBy,
          searchP1,
          setSearchP1,
        })
      )}

      <Button type="submit" variant="contained" style={{ justifySelf: 'end' }}>
        search
      </Button>

      {/* Second param or wildcard info */}
      {enableP2(searchBy) ? (
        <>
          <label
            id="search-parameter-2"
            style={{ gridColumn: 3, justifySelf: 'end' }}>
            {path<string>(searchBy)(labelP2)}
          </label>
          {renderP2({
            searchP2,
            setSearchP2,
          })}
        </>
      ) : (
        <label id="search-parameter-help" style={{ gridColumn: 4 }}>
          For wildcard match, please type %25 after your input.
        </label>
      )}
    </Form>
  </>
);

const Form = styled('form')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr 3fr) 1fr repeat(7, 1fr)',
  alignItems: 'center',
  justifyItems: 'center',
  gap: '1em',
}));
